import React from 'react';
import styled from "styled-components";
import CartViewAction from "../cart/CartViewAction";
import ShopperProfileWithCart from "../ShopperProfileWithCart";
import Icn from "../Icn";
import {api} from "../../maps/data.js";
import useZibi from "../../zibi/UseZibi";

const WrapperStyled = styled.div`
  width: 100%;
  display: grid;
`;

const ShopperListContainerStyled = styled.div`
  display: block;
  overflow-y: auto;
  height: 95%;
  padding-bottom: 10px;
`;

const ShopperListCartStyled = styled.div`
  text-align: center;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  justify-items: left;
  grid-gap: 10px;
  padding: 0 10px;

  .cart-view-action {
    display: grid;
    justify-self: baseline;
  }
`;

const ShopperCartDrawer = ({allShoppersAsMapObj, shopperOnline_list}) => {
    const [shopperProductsCart, set_shopperProductsCart] = useZibi('shopperProductsCart');

    return (
        <WrapperStyled>
            <ShopperListCartStyled>
                <b>Shoppers cart</b>
                <CartViewAction />
                <Icn
                    style={{cursor: "pointer"}}
                    onClick={async () => {
                        await api({
                            type: 'resetShopperCart'
                        });
                        set_shopperProductsCart({});

                }}>
                    restartAltIcon
                </Icn>
            </ShopperListCartStyled>

            <ShopperListContainerStyled className="dynamic-rows">
                {
                    allShoppersAsMapObj && shopperProductsCart && shopperOnline_list.map((shopperOnline) => {
                        const shopper = allShoppersAsMapObj[shopperOnline.shopperId];
                        if (!shopper) {
                            return null;
                        }
                        return (
                            <ShopperProfileWithCart
                                shopper={shopper}
                                key={shopper._id + 'shopperOnline'}
                                cartData={shopperProductsCart[shopper._id]}
                            />
                        );
                    })
                }
            </ShopperListContainerStyled>
        </WrapperStyled>
    );
};

export default ShopperCartDrawer;